import { SingleEventHandler } from '@edreamsodigeo/frontend-core';
const TravellerChangeWarningModalHandler = SingleEventHandler();
export default TravellerChangeWarningModalHandler;